import { useGetParticipantVideoCallBookingInformationQuery } from './videoCallBookingHeaderQueries.generated'

export const useGetParticipantVideoCallBookingInformation = (uid: string) => {
  const { data, loading, error, refetch } = useGetParticipantVideoCallBookingInformationQuery({
    variables: { uid },
  })

  return {
    data,
    loading,
    error,
    refetch,
  }
}
